import React, {useEffect, useState} from "react";

import Icon from "../../Icon/Icon";
import BarcodePatternIdentifierService from "./BarcodePatternIdentifier";
import Notify from "../../../services/Notify";

function ArcelorBarcode({asset}) {
    const [barcodeData, setBarcodeData] = useState({})
    const [importedEpc, setImportedEpc] = useState(false)
    const [hasError, setError] = useState(false)

    useEffect(() => {
        try {
            setImportedEpc(/X/.test(asset.internalBarcode.code))
            setBarcodeData(BarcodePatternIdentifierService.identify(asset.internalBarcode.code))
        } catch (e) {
            console.log('Não consegui converter o código de barras interno',e)
            setError(true);
            Notify.warning('Não consegui converter o código de barras interno');
        }
    }, [])

    return (
        <React.Fragment>
            <li className="list-group-item">
                <b><font
                    color="gray">{importedEpc ? "Etiqueta gerada pelo fornecedor" : "Etiqueta gerada por Arcelor Mittal"}</font></b>
            </li>
            <li className="list-group-item">
                <b>Código de Barras Interno </b>: {asset.internalBarcode.code} &nbsp;
                <Icon style={styles.exclamationTriangle}
                      icon={'exclamation-triangle'}
                      title="Não consegui converter o código de barras interno"
                />

            </li>
            {barcodeData.productType && (
                <li className="list-group-item">
                    <b>Lingote</b>: {barcodeData.productType}
                </li>
            )}
            {barcodeData.providerName && (
                <li className="list-group-item">
                    <b>Fornecedor</b>: {barcodeData.providerName}
                </li>
            )}
            {
                barcodeData.aluminiumPercentage && (
                    <li className="list-group-item">
                        <b>Alumínio (AL)</b>: {barcodeData.aluminiumPercentage}%
                    </li>
                )
            }
            {
                barcodeData.zincPercentage && (
                    <li className="list-group-item">
                        <b>Zinco (ZN)</b>: {barcodeData.zincPercentage}%
                    </li>
                )
            }
            {
                barcodeData.magnesioPercentage && (
                    <li className="list-group-item">
                        <b>Magnésio (MG)</b>: {barcodeData.magnesioPercentage}%
                    </li>
                )
            }
            {
                barcodeData.siliconPercentage && (
                    <li className="list-group-item">
                        <b>Silício (SI)</b>: {barcodeData.siliconPercentage}%
                    </li>
                )
            }
            {
                !!barcodeData.ironPercentage && (
                    <li className="list-group-item">
                        <b>Ferro (FE)</b>: {barcodeData.ironPercentage}%
                    </li>
                )
            }
            {
                !!barcodeData.lot && (
                    <li className="list-group-item">
                        <b>Lote</b>: {barcodeData.lot}
                    </li>
                )
            }
            {
               barcodeData.manufactureDate &&
                <li className="list-group-item">
                    <b>Data de fabricação da peça</b>: {barcodeData.manufactureDate}
                </li>
            }
        </React.Fragment>
    )
}
const styles = {
    exclamationTriangle: {
        fontSize:"20px",
        color:"orange"
    }
}

export default ArcelorBarcode



// WEBPACK FOOTER //
// ./src/component/Asset/barcode/ArcelorBarcode.js